import React from "react"

import { ArrowLeftIcon, ArrowPathIcon, ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline"
import { Form, Link, useLoaderData } from "react-router-dom"

import { Bee } from "../BeeKit"
import { MainHeading } from "~/src/components/MainHeading"

export type DashboardStoreCollectionItemSettingsProps = {
  backHref: string
  title: string
  storeUrl: string
  reorderHref?: string
}

export function DashboardStoreCollectionItemSettings() {
  const { backHref, title, reorderHref, storeUrl } = useLoaderData<DashboardStoreCollectionItemSettingsProps>()

  return (
    <div className="my-3 flex flex-col bg-gray-50 @container">
      <Link
        to={backHref}
        className="mx-6 mr-auto flex cursor-pointer items-center gap-2 text-lg text-gray-500 hover:underline"
      >
        <ArrowLeftIcon className="h-4 w-4" /> Back
      </Link>

      <hgroup className="mx-6 flex flex-col items-center @2xl:mx-6 @2xl:flex-row @2xl:gap-4">
        <MainHeading title={title} className="ml-0 mr-auto" />
        <div className="mb-4 flex w-full flex-col justify-between gap-2 @2xl:m-0 @2xl:w-fit @2xl:flex-row @2xl:justify-stretch">
          {reorderHref ? (
            <Bee.ButtonAnchor href={reorderHref} kind="secondary" className="flex items-center gap-3">
              <ArrowPathIcon className="h-6 w-6" />
              <span>Reorder item</span>
            </Bee.ButtonAnchor>
          ) : null}

          <Bee.ButtonAnchor href={storeUrl} kind="secondary" className="flex items-center gap-2">
            <ArrowTopRightOnSquareIcon className="h-6 w-6" />
            <span>View product in store</span>
          </Bee.ButtonAnchor>
        </div>
      </hgroup>

      <Form method="patch" className="flex flex-col gap-6 @2xl:mx-6">
        <div className="flex flex-col divide-y border border-gray-200 bg-white @2xl:rounded-lg">
          <section className="flex flex-col gap-6 p-6">
            <span className="text-lg font-medium text-gray-900">Details</span>
          </section>
          <section className="flex flex-col gap-6 p-6">
            <hgroup className="flex flex-col">
              <span className="text-lg font-medium text-gray-900">Display Information</span>
              <span className="text-sm text-gray-500">
                Editing the information in this section will update how the product appears on your store site
              </span>
            </hgroup>
          </section>
          <section className="flex flex-col gap-6 p-6">
            <span className="text-lg font-medium text-gray-900">Product Settings</span>
          </section>
        </div>
        <Bee.Button type="submit" className="mx-6">
          Save updates
        </Bee.Button>
      </Form>
    </div>
  )
}
